module.exports = __webpack_public_path__ + "img/two2Green.fc5aac00.jpg";